export class SqlEngine {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "engineType",
            "baseName": "engineType",
            "type": "SqlEngineType",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SqlEngineStatus",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "workerCount",
            "baseName": "workerCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "workerSize",
            "baseName": "workerSize",
            "type": "string",
            "format": ""
        },
        {
            "name": "autoscaling",
            "baseName": "autoscaling",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "useSpot",
            "baseName": "useSpot",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "minWorkers",
            "baseName": "minWorkers",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxWorkers",
            "baseName": "maxWorkers",
            "type": "number",
            "format": ""
        },
        {
            "name": "idleTimeoutMinutes",
            "baseName": "idleTimeoutMinutes",
            "type": "number",
            "format": ""
        },
        {
            "name": "currentReplicas",
            "baseName": "currentReplicas",
            "type": "number",
            "format": ""
        },
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return SqlEngine.attributeTypeMap;
    }
    constructor() {
    }
}
